import gql from 'graphql-tag'
import get from 'lodash/get'
import { INIT_QUERY_PARAMS } from 'config/consts'
import i18next from 'i18next'

export default {
	Query: {
		getClientPriceLevels: function (root, { onlyActive = true, defaultNames = true }, { cache }, info) {
			try {
				const getClientPriceLevelsQuery = gql`
				{
					cashAssist {
						getAppConfig {
							maxPriceLevel
						}
						getAppConfigAdditional {
							priceLevels
						}
					}
				}
			`
				const data = cache.readQuery({
					query: getClientPriceLevelsQuery,
					variables: INIT_QUERY_PARAMS,
				})
				const maxPriceLevel = get(data, 'cashAssist.getAppConfig.maxPriceLevel', 0)
				const priceLevels = get(data, 'cashAssist.getAppConfigAdditional.priceLevels', [])
				const requestedLevels = onlyActive ? priceLevels.slice(0, maxPriceLevel) : priceLevels
				return defaultNames ? requestedLevels.map((item, i) => item || `${i18next.t('product_section.strings.prices_label')} ${i + 1}`) : requestedLevels
			} catch (err) {
				console.log(err) // eslint-disable-line no-console
				return []
			}
		},
		getDiscountGroupNames: function (root, { defaultNames }, { cache }) {
			try {
				const getDiscountGroupNamesQuery = gql`
				{
					cashAssist {
						getAppConfigAdditional {
							discountGroupNames
						}
					}
				}
			`
				const data = cache.readQuery({
					query: getDiscountGroupNamesQuery,
					variables: INIT_QUERY_PARAMS,
				})
				const discountGroupNames = get(data, 'cashAssist.getAppConfigAdditional.discountGroupNames', [])
				return defaultNames
					? discountGroupNames.map((item, i) => {
						if (item) {
							return item
						}
						const defaultName = i18next.t('product_section.strings.discount_group')
						return `${defaultName} ${i + 1}`
					})
					: discountGroupNames
			} catch (err) {
				console.log(err) // eslint-disable-line no-console
				return []
			}
		},
		getLocale: function (_, __, { cache }) {
			try {
				const getLocaleQuery = gql`
						{
							cashAssist {
								getAppConfig {
									countryId
								}
							}
						}
					`;
				const data = cache.readQuery({
					query: getLocaleQuery,
					variables: INIT_QUERY_PARAMS,
				})
				const locale = get(data, 'cashAssist.getAppConfig.countryId')
				switch (Number(locale)) {
					case 1: return 'de-ch'
					case 2: return 'de'
					case 4: return 'en'
					case 78: return 'fr-FR'
					default: return 'de-ch'
				}
			} catch (err) {
				console.log(err) // eslint-disable-line no-console
				return null
			}
		},
		getMainCurrency: function (_, __, { cache }) {
			let languages = { EUR: '€', CHF: 'CHF' }
			try {
				const getMainCurrencyQuery = gql`
					{
						cashAssist {
							getAppConfig {
								mainCurrency
							}
						}
					}
				`
				const data = cache.readQuery({
					query: getMainCurrencyQuery,
					variables: INIT_QUERY_PARAMS,
				})
				const mainCurrency = get(data, 'cashAssist.getAppConfig.mainCurrency')
				return languages[mainCurrency]
			} catch (err) {
				console.log(err.message) // eslint-disable-line no-console
				return languages.CHF
			}
		}
	}
}
